<template>
  <div>
    <v-form
      @submit.prevent="login()"
      ref="form"
      lazy-validation
      class="login-form"
    >
      <v-text-field
        class="login-input"
        v-model="logForm.email"
        prepend-icon="mail"
        name="email"
        persistent-placeholder
        :label="$t('login.email')"
        type="email"
        :rules="requiredRule"
        :disabled="isLoading"
      ></v-text-field>
      <v-text-field
        class="mb-4"
        v-model="logForm.password"
        id="password"
        prepend-icon="lock"
        name="password"
        persistent-placeholder
        :label="$t('login.password')"
        :type="showPassword ? 'text' : 'password'"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showPassword = !showPassword"
        :rules="requiredRule"
        hide-details
        :disabled="isLoading"
      ></v-text-field>
      <v-btn
        class="mt-8"
        color="primary"
        block
        type="submit"
        :loading="isLoading"
      >
        {{ $t("login.login") }}
      </v-btn>
      <v-btn
        text
        block
        color="primary"
        @click="openPasswordResetDialog"
        class="mt-2"
        >{{ $t("login.forgotPassword") }}
      </v-btn>
    </v-form>
    <template v-if="$store.getters.registrationEnabled">
      <orSeparator />
      <v-btn color="primary" outlined block @click="openRegister()">
        {{ $t("login.register") }}
      </v-btn>
    </template>
    <passwordDialog ref="passwordDialog" :passwordDialog="passwordDialog" />
  </div>
</template>
<script>
import passwordDialog from "./passwordDialog.vue";
import OrSeparator from "@/components/layout/orSeperator.vue";
import { removeDataFromLocalStorage } from "../../api.js";
import { homePath } from "../../utils/access";

export default {
  components: { OrSeparator, passwordDialog },
  data() {
    return {
      showPassword: false,
      logForm: {
        email: "",
        password: "",
      },
      requiredRule: [(v) => !!v || this.$t("general.fieldNeedsToBeFilled")],
      passwordDialog: {
        open: false,
      },
      isLoading: false,
    };
  },
  created() {
    //reset snackbars and alerts
    this.removeDataFromLocalStorage();
  },
  mounted() {
    //react on url parameter reason
    if (
      this.$route.params.reason != "" &&
      this.$route.params.reason != "1" &&
      this.$route.params.reason === "isAuthenticated"
    ) {
      this.$store.dispatch("triggerUniversalAlert", {
        text: this.$t("login.inactivityMessage"),
        heading: this.$t("login.loggedOutHeading"),
        type: "warning",
      });
    }
  },
  methods: {
    removeDataFromLocalStorage,
    async createRedirectLink() {
      //create redirect link in the following format:
      let href;
      await this.$store.dispatch("getUserInfo");
      if (this.$route.params.redirect != 1) {
        //use redirect link as base link
        href = new URL(decodeURIComponent(this.$route.params.redirect));

        href.searchParams.append("formTypeParam", this.$route.params.mode);
        href.searchParams.append("redirectParam", this.$route.params.redirect);

        window.location.replace(href.toString());
      } else {
        //use default
        this.$router.push(homePath());
      }
    },
    login() {
      let vm = this;
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        //format email
        this.$store
          .dispatch("login", {
            email: this.logForm.email.trim().toLowerCase(),
            password: this.logForm.password.trim(),
          })
          .then((r) => {
            //redirect
            //this.$router.push("/app/tickets/all");
            //create redirect link when login success otherwise redirect to log-in
            r
              ? vm.createRedirectLink()
              : this.$router.push("/login/login/1/1/1");
            vm.loading = false;
          })
          .finally(() => (this.isLoading = false));
      }
    },
    openRegister() {
      this.$router.push("/register");
    },
    openPasswordResetDialog() {
      //check if email can be preset
      if (this.logForm.email) {
        this.$refs.passwordDialog.setEmail(
          this.logForm.email.trim().toLowerCase(),
        );
      }
      this.passwordDialog.open = true;
    },
  },
};
</script>
<style>
.login-form .i .login-form input:-webkit-autofill,
.login-form input:-webkit-autofill:hover,
.login-form input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.87) !important;
  caret-color: rgba(0, 0, 0, 0.87);
  transition: background-color 9999s ease-out 0s;
}
</style>
